export default __webpack_public_path__ + "static/media/bottle.7a2214e4.png";